import { UserFriendlyError } from "../../../../../common/utils/base_error";
import { ICreateEntradasEstoqueOrdemCompraUseCase } from "../../../presentation/useCases/create/create_entradas_estoque_ordem_compra_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

export class CreateEntradasEstoqueOrdemCompraUseCase implements ICreateEntradasEstoqueOrdemCompraUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async createEntradasEstoqueOrdemCompra(
    idOrdemCompra: number,
    idCentroCusto: number,
    data: Date | null,
    idsProdutosServicosEntregues: number[],
  ): Promise<void> {
    if (!Number.isSafeInteger(idOrdemCompra) || idOrdemCompra <= 0) {
      throw new UserFriendlyError("Ordem de compra inválida.");
    }

    if (!Number.isSafeInteger(idCentroCusto) || idCentroCusto <= 0) {
      throw new UserFriendlyError("Selecione um centro de custo válido.");
    }

    if (idsProdutosServicosEntregues.length === 0
      || idsProdutosServicosEntregues.some(id => !Number.isSafeInteger(id) || id <= 0)
      || new Set(idsProdutosServicosEntregues).size !== idsProdutosServicosEntregues.length) {
      throw new UserFriendlyError("A lista de produtos entregues está vazia ou contém itens inválidos.");
    }

    await this.repository.createEntradasEstoqueOrdemCompra(
      idOrdemCompra,
      idCentroCusto,
      data,
      idsProdutosServicosEntregues,
    );
  }
}
